import { mapState } from 'vuex';
import storypreview from "../listpreview/index.vue";
import f from '@/application/shared/functions.js'

export default {
    name: 'playlist',
    props: {
        ids : Array,
        story : Object
        
    },

    components : {
        storypreview
    },

    data : function(){

        return {
            loading : true,
            lastids : null,
            stories : {},
            selected : {},
            settings : {}
        }

    },

    created () {
        this.load()
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        playingstory : state => state.playingstory,
        playlist : state => state.playlist,
        fields : function(){
            return _.filter([
                {
                    id: 'loop',
                    input: 'checkbox',
                    text: 'caption.loopedplayback'
                },

                {
                    id: 'noimagesinstory',
                    input: 'checkbox',
                    text: 'caption.dontdisplayimages'
                },
                
                {
                    id: 'muted',
                    input: 'checkbox',
                    text: 'caption.mute'
                },

                f.touchDevice() ? {
                    id: 'buttonsblock',
                    input: 'checkbox',
                    text: 'caption.block'
                } : null

            ], (v) => {
                return v
            })
        },
        uids : function(state) {

            var aids = this.ids || this.lastids || []


            if (this.playlist){
                aids = this.playlist.ids.concat(aids)
            }
            else{
                if(this.story){
                    aids = [this.story.id].concat(aids)
                }
            }

            aids = _.uniq(aids)

            return aids
        },

        canstart : function(){
            return !_.isEmpty(this.selectedMap)
        },

        hasChanges : function(){
            if(this.playlist){
                return this.playlist.ids.join(',') != _.toArray(this.selectedMap).join(',')
            }
        },

        selectedMap : function(){

            var map = []

            _.each(this.selected, (v, i) => {
                if(v) map.push(i)
            })

            return map

        
        },

        uidsFromStories : function(){
            return _.map(this.stories || {}, (s, k) => {
                return k
            })
        }
    }),

    methods : {
        
        getlastuids : function(){

            return this.core.api.stories.getmyviews().then(views => {

                this.lastids = _.map(views, (v) => {
                    return v.story
                })

                return Promise.resolve()

            })

            //TODO
            //this.lastids = ['3a471b73-2a86-b727-2d8c-96d0721727a0', "112427ef-5e22-5688-bc9d-ad10f3659b14"]

            

        },
        load : function(){
            this.loading = true

           

            var pr = this.getlastuids

            if (this.playlist){
                this.settings = this.playlist.settings
                this.selected = {}

                _.each(this.playlist.ids, (id) => {
                    this.selected[id] = true
                })
            }
            else{
                this.settings = {
                    muted : this.$store.state.muted,
                    noimagesinstory : this.$store.state.noimagesinstory,
                    buttonsblock : this.$store.state.buttonsblock,
                    loop : false,

                }

                if (this.ids){
                    _.each(this.ids, (id) => {
                        this.selected[id] = true
                    })
                }

                if (this.story){
                    this.selected[this.story.id] = true
                }
            }

            pr().then(() => {
                return this.core.api.stories.gets(this.uids)
            }).then(r => {

                var s = {}

                _.each(r, (story, k) => {
                    if(!story.course && !story.circle) {
                        s[k] = story
                    }

                    else{
                        
                    }
                })

                console.log("RRR", r)

                this.stories = s

            }).catch(e => {
                this.loadingError = e
            }).finally(() => {
                this.loading = false
            })
        },

        select : function(id){
            this.selected[id] = this.$set(this.selected, id, !!!this.selected[id])
        },
        input : function(v){

            _.each(v, (_v, i)=> {
                if(!_v) v[i] = false
            })

            this.settings = v

        },

        apply : function(v){

            var playlist = {
                ...this.playlist,
                setting : {
                    ...this.settings
                },
                ids : this.selectedMap
            }

            this.$store.commit('playlist', playlist)

            var firstId = playlist.ids[0]
            var fromTime = 0

            if (this.story){
                firstId = this.story.id
                fromTime = this.story.time
            }

            this.$router.push({name : 'story', params : {id : firstId}, query : {time : fromTime}})

            this.$emit('close')
        },
        start : function(v){

            var playlist = {
                settings : {
                    ...this.settings
                },
                ids : this.selectedMap
            }

            this.$store.commit('playlist', playlist)

            var firstId = playlist.ids[0]
            var fromTime = 0

            if (this.story && this.story.id == firstId){
                fromTime = this.story.time
            }

            this.$router.push({name : 'story', params : {id : firstId}, query : {time : fromTime}})

            this.$emit('close')

        },
        close : function(v){
            this.$emit('close')
        },

        
    },
}